<template>
    <div class="interiorzone">
        <div class="toptit"><h2 class=" fl subheading">参数设置</h2></div>
        <div class="tabbox">
            <el-table
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    prop="name"
                    width="180"
                    label="参数名称"
                    >
                </el-table-column>
                <el-table-column
                    prop="value"
                    label="参数值"
                    >
                </el-table-column>
                <el-table-column
                    prop="desc"
                    label="参数说明"
                    >
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="80">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
                        </template>
                </el-table-column>
            </el-table>

            <el-dialog
                title="内容修改"
                :visible.sync="shows"
                width="400px"
                :close-on-click-modal='false'
                >
                <div>
                    <div class="demo-input-suffix">
                        参数名称:
                        <el-input
                            placeholder="请输入内容"
                            :disabled='true'
                            v-model="names">
                        </el-input>
                    </div>
                    <div class="demo-input-suffix">
                        参数值：
                        <el-input
                            placeholder="请输入内容"
                            v-model="vals">
                        </el-input>
                    </div>
                    <div class="demo-input-suffix">
                        参数说明：
                        <el-input
                            placeholder="请输入内容"
                            :disabled='true'
                            v-model="decs">
                        </el-input>
                    </div>
                    <div class="gogo">
                        <el-button class="trueChange" @click="changeClick" type="primary">确认修改</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }],
            currentPage:1,
            pageSize:10,
            shows:false,
            adjson:{},
            names:'',
            vals:'',
            decs:''
        }
    },
    mounted(){
        this.handleAjax()
    },
    methods:{
        handleClick(val){
            this.adjson=val
            this.names=val.name
            this.vals=val.value
            this.decs=val.desc
            this.shows=!this.shows
        },
        changeClick(){
            this.ajax.post(this.versatile.withurl +'/system/updatesystem',{bizContent:{name:this.names,value:this.vals}})
            .then(
                result=>{
                    if(result.data.status=='0000'){
                        swal({
                            text: '修改成功！',
                            timer: 3000,
                            buttons: false
                        })
                        this.shows=false
                        this.handleAjax()
                    }
                    else{
                        swal({
                            text: result.data.message,
                            timer: 3000,
                            buttons: false
                        })
                    }
                    }
            )
        },
        handleAjax(){
            this.ajax.post(this.versatile.withurl +'/system/getallsystem',{bizContent:{pageSize:this.pageSize,currentPage:this.currentPage}})
            .then(
                result=>{
                    if(result.data.status=='0000'){
                        this.tableData=result.data.data.responseList
                        console.log(this.tableData,'sssssssss')
                    }
                    else{
                        swal({
                            text: result.data.message,
                            timer: 3000,
                            buttons: false
                        })
                    }
                    }
            )
        },
    }
}
</script>

<style  scoped>
.toptit{
  width:100%;
  display:table;
  clear:both;
  margin-bottom:20px;
}
.gogo{
    text-align: center;
}
.trueChange{
    margin: auto;
    margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/toto.vue